import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiEndPointsForms } from '../common/apiUrls/api-end-points-forms';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  private baseUrl: any;
  private baseUrlTrans: any;
  private baseUrlReferral: any;
  private baseUrlRole: any;
  private baseURlOrg: any;
  private baseManageUserUrl: any;
  private isProjectExtended: boolean;
  private settingbaseUrl: any;
  baseUrlTask: string;
  private baseUrlCore: any;
  constructor(
    private _http: HttpClient,
    private apiAddress: ApiEndPointsForms,
    public env: EnvService,
    private constant: Constants
  ) {
    this.isProjectExtended = false;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.ManageContactsportNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.ManageContactsportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTrans =
        this.env.apiUrl + this.constant.ManageTranscationportNumber;

    // ── LOCAL TEST OVERRIDE ──
    // Referral endpoints (api/ReferralTemplate/*) AND the shared ManageTransaction
    // endpoints (FileManager / AIAutomation used by the AI tool) are routed to the
    // locally-running API so the referral + AI flow can be tested end-to-end with
    // the local code (e.g. the IsSystemGenerted patient-sheet fix). The AI tool
    // reads the sheet via GetFileManagerFileDetail on baseUrlTrans, so that must
    // also be local. BEFORE DEPLOY: delete these two override lines (baseUrlTrans
    // reverts to the env-derived value above; set baseUrlReferral = this.baseUrlTrans).
    this.baseUrlReferral = this.baseUrlTrans; //'http://localhost:50115/';
    //this.baseUrlTrans = 'http://localhost:50115/';
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlRole = this.constant.RolePortNumber;
    else this.baseUrlRole = this.env.apiUrl + this.constant.RolePortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
    else
      this.baseURlOrg = this.env.apiUrl + this.constant.ManageOrganizationPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseManageUserUrl = this.constant.ManageUserPortNumber;
    else
      this.baseManageUserUrl = this.env.apiUrl + this.constant.ManageUserPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTask = this.constant.ManageTask;
    else
      this.baseUrlTask = this.env.apiUrl + this.constant.ManageTask;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.settingbaseUrl = this.constant.SettingsPortNumber;
    else
      this.settingbaseUrl = this.env.apiUrl + this.constant.SettingsPortNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlCore = this.constant.ManageCoreportNumber;
    else
      this.baseUrlCore = this.env.apiUrl + this.constant.ManageCoreportNumber;
  }

  // private baseUrl = this.env.apiUrl+this.constant.ManageContactsportNumber;
  // private baseUrlTrans = this.constant.ManageTranscationportNumber;
  // //private baseUrlTrans = this.env.apiUrl+this.constant.ManageTranscationportNumber;
  // private baseUrlRole = this.constant.RolePortNumber;
  //private baseUrlRole = this.env.apiUrl+this.constant.RolePortNumber;

  CreateProjectFromFormLink(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CreateProjectFromFormLink;
    return this._http.post(apiURL, reqModel).pipe();
  }

  matchFormFolderUrlParameter(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.matchFormFolderUrlParameter;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getUserDetailsManageUser(userID): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getLoggedInUserDetailsManageUser;
    return this._http.post(apiURL, userID);
  }
  getUserOffices(userID): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getUserOffices;
    return this._http.post(apiURL, userID);
  }
  validateToken(validateTokenReqModel: any) {
    const apiCallingURl = this.baseManageUserUrl + this.apiAddress.validateUser;
    return this._http.post(apiCallingURl, validateTokenReqModel).pipe();
  }
  ShareFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ShareFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ShareForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ShareForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ModifyShareFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ModifyShareFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ModifyShareForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ModifyShareForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderSharedWithMeList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderWithFormTemplatesSharedWithMe(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderWithFormTemplatesSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFileManagerFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FileManagerFoldersWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FileManagerFoldersWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MergeTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MergeTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UseFormsTemplateForProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UseFormsTemplateForProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UseMasterTemplateForProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UseMasterTemplateForProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormFolderWithFormTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormFolderWithFormTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // MergeTemplate(reqModel): Observable<any> {
  //   const apiURL =
  //     this.baseUrlTrans + this.apiAddress.MergeTemplate;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }

  GetParentFormFolderHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetParentFormFolderHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormFolderDetail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFormFolderDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetFormDetail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFormDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFormTouches(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFormTouches;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormTouch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddFormTouch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RenameFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenameFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  configureFormFolderUrls(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.configureFormFolderUrls;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setIsprojectExtended(value: boolean) {
    this.isProjectExtended = value;
  }

  getIsprojectExtended() {
    return this.isProjectExtended;
  }

  RenameForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenameForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFormFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFormFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFormItems(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFormItems;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFormSharedTo(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFormSharedTo;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllFromFolderSharedRole(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllFromFolderSharedRole;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddFormFavorite(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddFormFavorite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RemoveDashboardFavoriteItem(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RemoveDashboardFavoriteItem;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteFormFavorite(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteFormFavorite;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroup(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateProjectGroupName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetGroupList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetGroupList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddRecentlyViewFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddRecentlyViewFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetRecentlyViewFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetRecentlyViewFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectStepFirst(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectStepFirst;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckIfPDFWillConvertToImage(reqModel): Observable<any> {
    const apiURL = "https://ecmpdftoimgapp-staging.azurewebsites.net/api/Convertor/CheckIfPDFWillConvertToImage";
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectStepSecond(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectStep2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddParticipantJsonStep3(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddParticipantJsonStep3;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UploadBlankImageToFormOrProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UploadBlankImageToFormOrProject;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GeneratePDF(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GeneratePDF;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetProjectDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdatePartcipantMessage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdatePartcipantMessage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAttachment(fileurl, filename): Observable<any> {
    //const queryParam = '?fileName=' + filePath;
    const queryParam = '?fileurl=' + fileurl + '&filename=' + filename;
    const apiURL = this.baseUrlTrans + this.apiAddress.getAttachment + '' + queryParam;
    return this._http.get(apiURL).pipe();
  }

  getTransactinalRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getTransactinalRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddEditProjectGroupRelationParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddEditProjectGroupRelationParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateParticipantDeatil(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateParticipantDeatil;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetContactListCoreImplementation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetContactListCoreImplementation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSharedAccessRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlRole + this.apiAddress.getSharedAccesslRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  RemoveGroupRelation(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RemoveGroupRelation;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReorderFormGroupRelations(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReorderFormGroupRelations;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDraftedProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDraftedProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteDraftedProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteDraftedprojects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getProjectFormEditorDetails(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectFormEditorDetails;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectInfoAsTemplete(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectInfoAsTemplete;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTaskGroupsByTaskList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTaskGroupsByTaskList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addTasklist(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.addTasklist;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameTasklist(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.renameTasklist;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetExterURLToken(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.GetExterURLToken;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SendExternalURLEmail(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.SendExternalURLEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetProjectParticicpantWithSigningLinkByProjectID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectParticicpantWithSigningLinkByProjectID;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTaskOrTaskListstatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskOrTaskListstatus;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateSingleTaskStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateSingleTaskStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTaskPriority(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskPriority;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetTemplateByID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.GetTemplateByID;
    return this._http.post(apiURL, reqModel).pipe();
  }
  Save3cNew(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.AddTask3c;
    return this._http.post(apiURL, reqModel).pipe();
  }
  ChangeFormFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ChangeFormFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddmessageStep4(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddmessageStep4;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckProjectNames(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CheckProjectNames;
    return this._http.post(apiURL, reqModel).pipe();
  }

  CheckProjectTemplateName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CheckProjectTemplateName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SearchFormFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchFormFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeletePrivateMessage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeletePrivateMessage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInboxProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getInboxProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteInboxSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deleteInboxSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteInboxProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteInboxProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DeleteSentProjects(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteSentProjects;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MoveSentProjectsToTrash(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.moveSentProjectsToTrash;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetTrashBoxItems(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetTrashBoxItems;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getParticipantJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getParticipantJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetSignNowJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSignNowJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  getTabularJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getTabularJson;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateParticipantJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateParticipantJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SaveSigningParticipantJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SaveSigningParticipantJson;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SaveSignNowDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SaveSignNowDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  UpdateTabularJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateTabularJson;
    return this._http.post(apiURL, reqModel).pipe();
  }

  MakeCopyOfFormTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MakeCopyOfFormTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }


  MakeMasterCopyOfFormTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MakeMasterCopyOfFormTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  copyAFormFromAOffice(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.copyAFormFromAOffice;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSentBoxItemParticipantList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSentBoxItemParticipantList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  EditParticipantEmail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.EditParticipantEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  remindParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.remindParticipant;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ResendEmail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ResendEmail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ResendRemainderProjectReport(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ResendRemainderProjectReport;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReopenSignatureLink(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReopenSignatureLink;
    return this._http.post(apiURL, reqModel).pipe();
  }
  renewProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RenewProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  retryPdfToImage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.RetryPdfToImage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddAIDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddAIDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetResponseFromAIDoc(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetResponseFromAIDoc;
    return this._http.post(apiURL, reqModel).pipe();
  }
  GetAIDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAIDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  DeleteAIDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DeleteAIDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  ReplaceExistingPDF(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ReplaceExistingPDF;
    return this._http.post(apiURL, reqModel).pipe();
  }

  compressPDF(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.CompressPDF;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetPageCount(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetPageCount;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectAttachmentDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectAttachmentDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInboxItemParticipantList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetInBoxItemParticipantList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFieldValuesForAutoFill(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetContactDetailForAutoFill;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFieldValuesForAutoFillCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetCoreDetailForAutoFill;
    return this._http.post(apiURL, reqModel).pipe();
  }

  declineForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.declineForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FileManagerItemsWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FileManagerItemsWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFoldersListForFML(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileManagerFolderList;
    return this._http.post(apiURL, reqModel).pipe();
  }

   getOfficeFolders(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOfficeFolders;
    return this._http.post(apiURL, reqModel).pipe();
  }
  
  
  RequestCCCUrlVisit(reqModel, type): Observable<any> {
    if (type.toLowerCase() == "core") {
      const apiURL = this.baseUrlTrans + this.apiAddress.RequestCoreUrlVisit;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "contact") {
      const apiURL = this.baseUrlTrans + this.apiAddress.RequestContactUrlVisit;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "company") {
      const apiURL = this.baseUrlTrans + this.apiAddress.RequestCompanyUrlVisit;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  // RequestContactUrlVisit(reqModel): Observable<any> {
  //   const apiURL = this.baseUrlTrans + this.apiAddress.RequestContactUrlVisit;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }

  // RequestCompanyUrlVisit(reqModel): Observable<any> {
  //   const apiURL = this.baseUrlTrans + this.apiAddress.RequestCompanyUrlVisit;
  //   return this._http.post(apiURL, reqModel).pipe();
  // }

  ParticipantDocumentUploadCCC(reqModel, type): Observable<any> {
    if (type.toLowerCase() == "core") {
      const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadCore;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "contact") {
      const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadContact;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type.toLowerCase() == "company") {
      const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadCompany;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  ParticipantDocumentUploadCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ParticipantDocumentUploadCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddProjectEventLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddProjectEventLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetProjectAuditLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectAuditLog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  NotificationPost(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.NotificationPost;
    //return this._http.post(apiURL, reqModel).pipe();
    return new Observable<Object>();
  }

  // To get Notification List
  getNotificationList(data: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.NotificationList;
    //  return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }

  // To get Unread Notification count
  GetUnreadNotificationsCount(data: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetUnreadNotificationsCount;
    //  return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }

  // MarkUnreadNotifications
  MarkUnreadNotifications(data: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.MarkUnreadNotifications;
    //return this._http.post(apiURL, data).pipe();
    return new Observable<Object>();
  }

  AddHtMLForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddHtMLForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateHTMLForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateHTMLForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransCities(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchTransCities;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchTransZip(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchTransZip;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getStateList(countryId): Observable<any> {
    const apiCallingURl = this.baseURlOrg + this.apiAddress.getStateList;
    return this._http.post(apiCallingURl, countryId).pipe();
  }

  getDashboardStats(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDashboardStats;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDashboard3cGraphData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDashboard3cGraphData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddDashboardFavoriteItem(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddDashboardFavoriteItem;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DashboardFavoriteItems(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DashboardFavoriteItems;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getDashboardSignatureGraphData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getDashboardSignatureGraphData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addNote(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addNote;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deleteNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }
  deletePortalNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.deletePortalNotes;
    // return this._http.post(apiURL, reqModel).pipe();


    // const apiURL = this.baseUrlTrans + this.apiAddress.addPersonalNote;   
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();

  }

  getCCCList(reqModel, type): Observable<any> {
    if (type == "Core") {
      const apiURL = this.baseUrlTrans + this.apiAddress.getCoreListing;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == "Contact") {
      const apiURL = this.baseUrlTrans + this.apiAddress.getContactListing;
      return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == "Company") {
      const apiURL = this.baseUrlTrans + this.apiAddress.getCompanyListing;
      return this._http.post(apiURL, reqModel).pipe();
    }
  }

  GetSharedWithMeFileManager(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManager;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetSharedWithMeFileManagerWithHierarchy(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetSharedWithMeFileManagerWithHierarchy;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetMasterTemplateCategoryList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateProjectGroupRelationName(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateProjectGroupRelationName;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getProjectFinalDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getProjectFinalDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  generateFinalDocumentsThroughSignaturePage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.generateFinalDocumentsThroughSignaturePage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GenerateFInalDocumentsThroughSignaturePageNewPDFFunctionality(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GenerateFInalDocumentsThroughSignaturePageNewPDFFunctionality;
    return this._http.post(apiURL, reqModel).pipe();
  }

  projectFinishBySender(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.projectFinishBySender;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getHtmlForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormHtml;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getHtmlFormData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getHtmlFormData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetProjectsByFormID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetProjectsByFormID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DownloadMultipleAsZipAsync(reqModel: any): Promise<Blob> {
    const endpoint = this.baseUrlTrans + this.apiAddress.DownloadMultipleAsZipAsync;
    return this._http.post(endpoint, reqModel, { responseType: 'blob' }).toPromise();
  }

  FetchDocAsync(reqModel: any): Promise<Blob> {
    const endpoint = this.baseUrlTrans + this.apiAddress.FetchDocAsync;
    return this._http.post(endpoint, reqModel, { responseType: 'blob' }).toPromise();
  }
  SubmitHTMLForm(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SubmitHTMLForm;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOrganizationFormTemplateGallery(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOrganizationFormTemplateGallery;
    return this._http.post(apiURL, reqModel).pipe();
  }


  addSignature(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.addSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addDefaultSignature(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.addDefaultSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addInitial(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.addInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeDefaultInitial(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.changeDefaultInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSignaturesAndInitials(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getSignaturesAndInitials;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeSignature(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.removeSignature;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeInitial(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.removeInitial;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFilemanagerFile(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addFileManagerFile;
    return this._http.post(apiURL, reqModel).pipe();
  }

  verifyFileManagerFolderUrl(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.verifyFileManagerFolderUrl;
    return this._http.post(apiURL, reqModel).pipe();
  }

  IsCheckIn(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.isCheckIn;
    return this._http.post(apiURL, reqModel).pipe();
  }


  archivedTemplateUrlSentLog(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTemplateUrlSentLog;
    return this._http.post(apiURL, reqModel).pipe();
  }


  GetFileManagerFileDetail(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFileManagerFileDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddVectorFileID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddVectorFileID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetOCRJSonDataByURL(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetOCRJSonDataByURL;
    return this._http.post(apiURL, reqModel).pipe();
  }

  runAIButton_4o_Run_Gemini(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetGoogleGeminiResponseGetQuestionAIResponse;
    return this._http.post(apiURL, reqModel).pipe();
  }

  runAIButton_4o_Run_Gemini_NLP(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetGoogleGeminiResponseFieldsValuesforNLP;
    return this._http.post(apiURL, reqModel).pipe();
  }

  prepareOCRFiles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.prepareOCRFiles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  processDocument(url: string, userId: string, officeId: string, organizationId: string, pdftext: string = ""): Observable<any> {
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/process_document_url';
    //  const params = new HttpParams()
    //    .set('url', url)
    //    .set('UserID', userId)
    //    .set('OfficeID', officeId)
    //    .set('OrganizationID', organizationId)
    //    .set('pdftext', pdftext);
    const body = {
      url: url,
      UserID: userId,
      OfficeID: officeId,
      OrganizationID: organizationId,
      pdftext: pdftext
    };
    // return this._http.post(apiURL, null, { params, observe: 'response' }).pipe(
    return this._http.post(apiURL, body, { observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, message: response.body['message'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  query_vector_dbFields(query: string, documentId: string): Observable<any> {
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/query_vector_dbFields';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      query: query,
      documentid: documentId
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }
  saveAIChatHistory(chatHistory): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.saveAIChatHistory;
    return this._http.post(apiURL, chatHistory).pipe();
  }
  GetAllAIChatHostory(chatHistory): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getAllAIChatHistory;
    return this._http.post(apiURL, chatHistory).pipe();
  }
  aiChat_Query_vector_db(query: string, documentId: string): Observable<any> {
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/aiChatResponse';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    const body = {
      query: query,
      documentid: documentId
    };
    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  getFieldsValuesforNLP(query: string, ocrtextfileurl: string): Observable<any> {
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/getFieldsValuesforNLP';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      query: query,
      ocrtextfileurl: ocrtextfileurl
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }


  query_vector_db(query: string, documentId: string, prompt_input: string = ""): Observable<any> {
    // const apiURL='http://127.0.0.1:8000/documents/query_vector_db';
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/query_vector_db';

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      query: query,
      documentid: documentId,
      prompt_input: prompt_input
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  submit_prompt_4o(url_pdf: string, prompt_input: string = "", isNta: boolean = false, pdfTextFromOCR: string = ""): Observable<any> {
    //const apiURL='http://127.0.0.1:8000/documents/submit-prompt-4o';
    //const apiURL='https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/new-submit-prompt-4o';
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/submit-prompt-4o';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      url_pdf: url_pdf,
      prompt: prompt_input,
      isNta: isNta,
      pdfTextFromOCR: pdfTextFromOCR
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }


  submit_prompt_4o_onGivenContext(prompt_input: string): Observable<any> {
    //const apiURL='http://127.0.0.1:8000/documents/submit-prompt-4o';
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/submit-prompt-4o-onGivenContext';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      prompt: prompt_input
    };
    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  new_submit_prompt_4o(ocrtextfileurl: string, prompt_input: string, isNta: boolean): Observable<any> {
    //const apiURL='http://127.0.0.1:8000/documents/submit-prompt-4o';
    const apiURL = 'https://pythondocumentchatapi-fud4a5bqduengkgk.eastus-01.azurewebsites.net/documents/new-submit-prompt-4o';
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      ocrtextfileurl: ocrtextfileurl,
      prompt: prompt_input,
      isNta: isNta,
      //pdfTextFromOCR:pdfTextFromOCR
    };

    return this._http.post(apiURL, body, { headers, observe: 'response' }).pipe(
      map(response => {
        if (response.status === 200) {
          return { success: true, response: response.body['response'] };
        } else {
          return { success: false, message: response.body['message'] };
        }
      }),
      catchError((error) => {
        return throwError({ success: false, message: error.message });
      })
    );
  }

  DownloadDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DownloadDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalDatafor3C(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDatafor3C;
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    // return this._http.post(apiURL, reqModel).pipe();
  }

  getOfficeDetail(reqModel): Observable<any> {
    const apiURL = this.baseURlOrg + this.apiAddress.getOfficeDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalUser3Cs(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalUser3Cs;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  CheckLoginTokenEXpiry(loginReqModel: any) {
    const apiCallingURl = this.baseManageUserUrl + this.apiAddress.CheckLoginTokenEXpiry;
    return this._http.post(apiCallingURl, loginReqModel).pipe();
  }

  addNotePortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addNotePortal;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    // const apiURL = this.baseUrlTrans + this.apiAddress.addNotePortal;
    // return this._http.post(apiURL, reqModel).pipe();
  }

  addPersonalNotePortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addPersonalNote;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    // const apiURL = this.baseUrlTrans + this.apiAddress.addPersonalNote;
    // return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalDataforHome(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalBroadcastingMessages(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalBroadcastingMessages;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalUnreadNotifications(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalUnreadNotifications;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }


  getCompletedActionsfor3C(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getCompletedActionsfor3C;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDocuments;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }

  readNotification(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.readNotification;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }

  getThirdPartyApis(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.getThirdPartyApis;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadCCCDocument(reqModel, type): Observable<any> {
    if (type == 1) {
      const apiURL = this.baseUrlTrans + this.apiAddress.addCoreMultiDocumentFromPortal;
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == 2) {
      const apiURL = this.baseUrlTrans + this.apiAddress.adContactMultiDocumentFromPortal;
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == 3) {
      const apiURL = this.baseUrlTrans + this.apiAddress.addCompanyMultiDocumentFromPortal;
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }


  }


  replaceCCCDocumentPortal(reqModel, type): Observable<any> {
    if (type == 1) {
      const apiURL = this.baseUrlTrans + this.apiAddress.uploadCoreDocument;
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == 2) {
      const apiURL = this.baseUrlTrans + this.apiAddress.uploadContactDocument;
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }
    if (type == 3) {
      const apiURL = this.baseUrlTrans + this.apiAddress.uploadCompanyDocument;
      // Retrieve the token from local storage
      const token = sessionStorage.getItem('LoginToken');

      // Prepare the headers
      const httpHeaders = new HttpHeaders({
        'Authorization': `Bearer ${token}`
      });
      return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
      //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
      //  return this._http.post(apiURL, reqModel).pipe();
    }
  }

  formShareOnPortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.formShareOnPortal;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPortalFormsforHome(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalFormsforHome;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }

  searchCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFileItemsByProjectId(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetFileItemsByProjectId;
    return this._http.post(apiURL, reqModel).pipe();
  }


  GetRelationByTaskTemplateID(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetRelationByTaskTemplateID;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchContact(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

  searchCompany(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.searchCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getSynonyms(reqModel): Observable<any> {
    const apiURL = this.settingbaseUrl + this.apiAddress.getSynonyms;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getAllFieldsForAITool(reqModel): Observable<any> {
    const apiURL = this.settingbaseUrl + this.apiAddress.getAllFieldsForAITool;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOCRTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOCRTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addField(dataModel) {
    const apiCallingURl = this.settingbaseUrl + this.apiAddress.addField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }


  getOCRModels(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOCRModels;
    return this._http.post(apiURL, reqModel).pipe();
  }

  extractDataWithFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.extractDataWithFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addOcrTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addOcrTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOCRTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOCRTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getOCRTemplateFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getOCRTemplateFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addMappedKeyValueData(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addMappedKeyValueData;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SearchFieldName(dataModel: any) {
    const apiCallingURl = this.settingbaseUrl + this.apiAddress.SearchFieldName;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getCustomdetails(dataModel) {
    const apiCallingURl = this.settingbaseUrl + this.apiAddress.getFieldDetailForTab;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  AddFieldFolderMappingForExistingField(dataModel) {
    const apiCallingURl = this.settingbaseUrl + this.apiAddress.AddFieldFolderMappingForExistingField;
    return this._http.post(apiCallingURl, dataModel).pipe();
  }

  getNLPTemplateCategories(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getNLPTemplateCategories;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addNLPTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addNLPTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getNLPTemplates(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getNLPTemplates;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getNLPQueries(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getNLPQueries;
    return this._http.post(apiURL, reqModel).pipe();
  }

  renameNLPTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.renameNLPTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  activateNLPTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.activateNLPTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeNLPTemplates(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrlTrans + this.apiAddress.removeNLPTemplates;
    return this._http.delete(apiURL, options).pipe();
  }

  updateNLPTemplate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateNLPTemplate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  mergePdfFiles(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.mergePdfFiles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreFeildList(reqModel): Observable<any> {
    const apiURL = this.baseUrlCore + this.apiAddress.getCoreFeildList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  manageFormUrlFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.manageFormUrlFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  manageProjectUrlFields(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.manageProjectUrlFields;
    return this._http.post(apiURL, reqModel).pipe();
  }

  manageProjectFolderUrlParams(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.manageProjectFolderUrlParams;
    return this._http.post(apiURL, reqModel).pipe();
  }

  manageFormFolderUrlParams(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.manageFormFolderUrlParams;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFileAIPrompt(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addFileAIPrompt;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFileAIPrompt(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFileAIPrompt;
    return this._http.post(apiURL, reqModel).pipe();
  }

  SendMedicationToCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SendMedicationToCore;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SendNTAToCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SendNTAToCore;
    return this._http.post(apiURL, reqModel).pipe();
  }
  SendPromptsToCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.SendPromptsToCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetAllSystemPrompt(): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetAllSystemPrompt;
    return this._http.get(apiURL).pipe();
  }
  removeFileAIPrompts(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.removeFileAIPrompts;
    return this._http.post(apiURL, reqModel).pipe();
    // const options = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //   }),
    //   body: reqModel
    // };
    // const apiURL = this.baseUrlTrans + this.apiAddress.removeFileAIPrompts;
    // return this._http.delete(apiURL, options).pipe();
  }

  disableSignaturePageAutofill(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.disableSignaturePageAutofill;
    return this._http.post(apiURL, reqModel).pipe();
  }

  disableUrlParameterConfiguration(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.disableUrlParameterConfiguration;
    return this._http.post(apiURL, reqModel).pipe();
  }

  disableFolderUrlParameterConfiguration(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.disableFolderUrlParameterConfiguration;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addWebFormUserSetting(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addWebFormUserSetting;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPDFFormReport(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPDFFormReport;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addPDFFormUserSetting(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addPDFFormUserSetting;
    return this._http.post(apiURL, reqModel).pipe();
  }

  mapCoreContactWithFinalDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.mapCoreContactWithFinalDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  pdfProjectAdvancedSearch(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.pdfProjectAdvancedSearch;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getFormsList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getFormsList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getUserList(data: any): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.userList;
    return this._http.post(apiURL, data).pipe();
  }

  AddCreateProjectforPlaceholderCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholderCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCreateProjectforPlaceholderContact(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholderContact;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCreateProjectforPlaceholderCompany(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholderCompany;
    return this._http.post(apiURL, reqModel).pipe();
  }


  reorderFileAIPrompt(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.reorderFileAIPrompt;
    return this._http.post(apiURL, reqModel).pipe();
  }

  resendEmailtoParticipants(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.resendEmailtoParticipants;
    return this._http.post(apiURL, reqModel).pipe();
  }

  pushMergedDocumentsTo3C(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.pushMergedDocumentsTo3C;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getMergedFileHistory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getMergedFileHistory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetUserList(reqModel): Observable<any> {
    const apiURL = this.baseManageUserUrl + this.apiAddress.GetUserList;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getTypeOfParticipant(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getTypeOfParticipants;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeParticipantColor(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.changeParticipantColor;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeParticipantFromSignaturePage(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.changeParticipantFromSignaturePage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  canThisPdfOpenforModifyByBytes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.canThisPdfOpenforModifyByBytes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  canThisPdfOpenforModifyByUrl(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.canThisPdfOpenforModifyByUrl;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadPortalDocinChunks(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.uploadPortalDocinChunks;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  getStatusisDocReadyforSign(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getStatusisDocReadyforSign;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  getPortalDocumentPages(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDocumentPages;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  updatePortalDocJson(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updatePortalDocJson;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  removePortalDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.removePortalDocument;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  renamePortalDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.renamePortalDocument;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
  }

  getSNFDashboardCores(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getSNFDashboardCores;
    return this._http.post(apiURL, reqModel).pipe();
  }

  autoFillCoreDataintoProject(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.autoFillCoreDataintoProject;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeProcessStageForCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.changeProcessStageForCore;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getNormalAndSharedContacts(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getNormalAndSharedContacts;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCoreItemForPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCoreItemForPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  DownloadCoreDocument(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.DownloadCoreDocument;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FillPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FillPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getPDPMCores(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPDPMCores;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetMedicaidApprovalCores(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetMedicaidApprovalCores;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getPDPMStages(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getPDPMStages;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeMedicalCategoryForCore(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.changeMedicalCategoryForCore;
    return this._http.post(apiURL, reqModel).pipe();
  }
  openEpisode(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.openEpisode;
    return this._http.post(apiURL, reqModel).pipe();
  }
  processRefreshAI(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.processRefreshAI;
    return this._http.post(apiURL, reqModel).pipe();
  }

  processNTAOnGivenDocuments(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.processNTAOnGivenDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }
  setCoreArchive(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.setCoreArchive;
    return this._http.post(apiURL, reqModel).pipe();
  }

  setCoreActivate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.setCoreActivate;
    return this._http.post(apiURL, reqModel).pipe();
  }
  archiveEpisodes(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.archiveEpisodes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  coreMedicalStatsUpdate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.coreMedicalStatsUpdate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addFavoriteItemForQuickLink(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addFavoriteItemForQuickLink;
    return this._http.post(apiURL, reqModel).pipe();
  }

  AddCreateProjectforPlaceholder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.AddCreateProjectforPlaceholder;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FavoriteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FavoriteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }
  ImportantCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ImportantCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }
  ImportantDeleteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.ImportantDeleteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }

  FavoriteDeleteCoreTransaction(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.FavoriteDeleteCoreTransaction;
    return this._http.post(apiURL, reqModel).pipe();
  }

  GetMedicaidApprovalStatuses(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetMedicaidApprovalStatuses;
    return this._http.post(apiURL, reqModel).pipe();
  }

  UpdateMedicaidApprovalsAndNTACheckInCheckOutDate(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.UpdateMedicaidApprovalsAndNTACheckInCheckOutDate;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getMedicaidEligibilityStatuses(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.GetMedicaidEligibilityStatuses;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getMedicaidRecordsCounts(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getMedicaidRecordsCounts;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeCorefromMedicalCategory(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.removeCorefromMedicalCategory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  uploadChunk(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.uploadChunk;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getReferralQuestionAnswers(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getReferralQuestionAnswers;
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.removeThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.updateThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  reorderThresholdRules(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.reorderThresholdRules;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeStatusForReferralQuestion(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.changeStatusForReferralQuestion;
    return this._http.post(apiURL, reqModel).pipe();
  }

  changeAIAnswerForReferralQuestion(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.changeAIAnswerForReferralQuestion;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getCoreList(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getCoreListing;
    return this._http.post(apiURL, reqModel).pipe();
  }


  getLiveReferralQueues(reqModel: any): Observable<any> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'GetLiveReferralQueues'), reqModel);
  }
  createCarePortReferral(reqModel: any): Observable<any> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'CreateCarePortReferral'), reqModel);
  }
  liveReferralWorkspace(reqModel: any): Observable<any> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'LiveReferralWorkspace'), reqModel);
  }
  prepareLiveReferral(reqModel: any): Observable<any> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'PrepareLiveReferral'), reqModel);
  }
  retryCarePortCorePacket(reqModel: any): Observable<any> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'RetryCarePortCorePacket'), reqModel);
  }
  downloadClinicalSummarySource(reqModel: any): Observable<Blob> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'DownloadLiveReferralDocument'),
      { ...reqModel, kind: 'clinical-source' }, { responseType: 'blob' });
  }
  getCarePortClinicalSummary(reqModel: any): Observable<any> { return this.readLiveReferral(reqModel, 'clinical-summary'); }
  private readLiveReferral(reqModel: any, kind: string): Observable<any> {
    return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'ReadLiveReferral'), { ...reqModel, kind });
  }
  getReferralQueues(reqModel): Observable<any> {
     const apiURL = this.baseUrlReferral + this.apiAddress.getReferralQueues;
    return this._http.post(apiURL, reqModel).pipe();
  }

  declineReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.declineReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

  acceptReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.acceptReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addNoteForReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.addNoteForReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateReferralWorkflowStatus(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.updateReferralWorkflowStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // ── External referral portal sync (Curaspan / ExtendedCare adapters) ──

  syncExternalReferrals(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.syncExternalReferrals;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // Settings -> External Referral Sources (SuperAdmin catalog + per-office credentials)
  getExternalReferralSourceCatalog(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getExternalReferralSourceCatalog;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveExternalReferralSource(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.saveExternalReferralSource;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getUserExternalReferralConfigs(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getUserExternalReferralConfigs;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveUserExternalReferralCredentials(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.saveUserExternalReferralCredentials;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // [credential-verify 2026-10-14] save, then log in at the portal; answer = { verified, credentialState, message, sites, defaultMappingsCreated }
  verifyUserExternalReferralCredentials(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.verifyUserExternalReferralCredentials;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // [credential-verify 2026-10-14] clear the user's login for one source (optionally the org's mappings too)
  resetUserExternalReferralSource(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.resetUserExternalReferralSource;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // Org-level facility → office mapping (shared by all users/offices of the org).
  getExternalFacilityOfficeMapSetup(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getExternalFacilityOfficeMapSetup;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveExternalFacilityOfficeMap(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.saveExternalFacilityOfficeMap;
    return this._http.post(apiURL, reqModel).pipe();
  }

  deleteExternalFacilityOfficeMap(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.deleteExternalFacilityOfficeMap;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // Decoupled admission: attach a freshly created resident to an accepted
  // referral — possibly under a different recipient facility's office.
  attachResidentToReferral(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.attachResidentToReferral;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // [per-office 2026-10-04] AI tool resident picker on a referral document
  setReferralResidentFromAITool(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.setReferralResidentFromAITool;
    return this._http.post(apiURL, reqModel).pipe();
  }

  syncSingleExternalReferral(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.syncSingleExternalReferral;
    return this._http.post(apiURL, reqModel).pipe();
  }

  probeExternalReferrals(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.probeExternalReferrals;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // High-cost medication check (referral screen)
  runReferralMedCheck(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.runReferralMedCheck;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getReferralMedCheckResult(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getReferralMedCheckResult;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // ExtendedCare response actions + hospital messaging
  getExternalDeclineReasons(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getExternalDeclineReasons;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendExternalReferralResponse(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.sendExternalReferralResponse;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getExternalReferralMessages(reqModel: any): Observable<any> {
    if (reqModel.externalReferralKey) return this.readLiveReferral(reqModel, 'messages');
    const apiURL = this.baseUrlReferral + this.apiAddress.getExternalReferralMessages;
    return this._http.post(apiURL, reqModel).pipe();
  }

  sendExternalReferralMessage(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.sendExternalReferralMessage;
    return this._http.post(apiURL, reqModel).pipe();
  }

  markExternalReferralMessagesRead(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.markExternalReferralMessagesRead;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getExternalReferralDetail(reqModel: any): Observable<any> {
    if (reqModel.externalReferralKey) return this.readLiveReferral(reqModel, 'detail');
    const apiURL = this.baseUrlReferral + this.apiAddress.getExternalReferralDetail;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getExternalReferralDocuments(reqModel: any): Observable<any> {
    if (reqModel.externalReferralKey) return this.readLiveReferral(reqModel, 'documents');
    const apiURL = this.baseUrlReferral + this.apiAddress.getExternalReferralDocuments;
    return this._http.post(apiURL, reqModel).pipe();
  }

  downloadExternalReferralDocument(reqModel: any): Observable<Blob> {
    if (reqModel.externalReferralKey) return this._http.post(this.baseUrlReferral + this.apiAddress.getReferralQueues.replace('GetReferralQueues', 'DownloadLiveReferralDocument'), reqModel, { responseType: 'blob' });
    const apiURL = this.baseUrlReferral + this.apiAddress.downloadExternalReferralDocument;
    return this._http.post(apiURL, reqModel, { responseType: 'blob' }).pipe();
  }

  runQualifyingForExternalReferral(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.runQualifyingForExternalReferral;
    return this._http.post(apiURL, reqModel).pipe();
  }

  runScreeningWithDocsForExternalReferral(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.runScreeningWithDocsForExternalReferral;
    return this._http.post(apiURL, reqModel).pipe();
  }

  runFullAIForExternalReferral(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.runFullAIForExternalReferral;
    return this._http.post(apiURL, reqModel).pipe();
  }

  runHippsKeyServicesForExternalReferral(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.runHippsKeyServicesForExternalReferral;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveWaystarVerification(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.saveWaystarVerification;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWaystarVerificationHistory(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getWaystarVerificationHistory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateWaystarAcceptance(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.updateWaystarAcceptance;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addWaystarNote(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.addWaystarNote;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWaystarNotes(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getWaystarNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveWaystarCoverageDetection(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.saveWaystarCoverageDetection;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // ── Unified Waystar Verification API (source-aware) ────────────────────────
  saveWaystarVerificationV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.saveWaystarVerificationV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateWaystarAcceptanceV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateWaystarAcceptanceV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveWaystarCoverageDetectionV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.saveWaystarCoverageDetectionV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWaystarVerificationHistoryV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getWaystarVerificationHistoryV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addWaystarNoteV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addWaystarNoteV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWaystarNotesV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getWaystarNotesV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWaystarReferralDocumentV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getWaystarReferralDocumentV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getWaystarProviderOnFileV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getWaystarProviderOnFileV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveWaystarProviderOnFileV2(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.saveWaystarProviderOnFileV2;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // ── CommunityGuard Background Check ────────────────────────────────────────
  runBackgroundCheck(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.runBackgroundCheck;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateBackgroundCheckDecision(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateBackgroundCheckDecision;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getBackgroundCheckHistory(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getBackgroundCheckHistory;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addBackgroundCheckNote(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.addBackgroundCheckNote;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getBackgroundCheckNotes(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getBackgroundCheckNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getBackgroundCheckAcceptancePrecheck(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getBackgroundCheckAcceptancePrecheck;
    return this._http.post(apiURL, reqModel).pipe();
  }

  detectCoverageRealtime(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.detectCoverageRealtime;
    return this._http.post(apiURL, reqModel).pipe();
  }

  verifyEligibility(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.verifyEligibility;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInsuranceVerificationQueue(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getInsuranceVerificationQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateInsuranceVerificationPriority(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateInsuranceVerificationPriority;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateInsuranceVerificationAssignee(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateInsuranceVerificationAssignee;
    return this._http.post(apiURL, reqModel).pipe();
  }

  updateInsuranceVerificationStatus(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.updateInsuranceVerificationStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

  softDeleteInsuranceVerifications(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.softDeleteInsuranceVerifications;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getInsuranceVerificationSlaConfig(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getInsuranceVerificationSlaConfig;
    return this._http.post(apiURL, reqModel).pipe();
  }

  saveInsuranceVerificationSlaConfig(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.saveInsuranceVerificationSlaConfig;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getActiveReferralLocations(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getActiveReferralLocations;
    return this._http.post(apiURL, reqModel).pipe();
  }

  associateLocationWithReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.associateLocationWithReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

   removeReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.removeReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

   uploadChunkForMultipleFilesMerge(reqModel):Observable<any>{
    const apiURL = this.baseUrlTrans + this.apiAddress.uploadChunkForMultipleFilesMerge;
    return this._http.post(apiURL, reqModel).pipe();
  }

    removeMemoryCardFromReferralQuestion(reqModel): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: reqModel
    };
    const apiURL = this.baseUrlReferral + this.apiAddress.removeMemoryCardFromReferralQuestion;
    return this._http.delete(apiURL, options).pipe();
  }

   restoreReferralQueue(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.restoreReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // [referral-notes 2026-10-03] notes as a list per office (add-only)
  getReferralNotes(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.getReferralNotes;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addReferralNote(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.addReferralNote;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // [internal-booked-here 2026-10-03] internal referral: to Booked Here (booked: true) / back to In-Progress
  setInternalReferralBooked(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.setInternalReferralBooked;
    return this._http.post(apiURL, reqModel).pipe();
  }

  // Flowtrics archive / unarchive (portal-style queue tabs, 2026-09-28)
  archiveReferralQueue(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.archiveReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }
  unarchiveReferralQueue(reqModel: any): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.unarchiveReferralQueue;
    return this._http.post(apiURL, reqModel).pipe();
  }

   reRunAutomationForAITool(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.reRunAutomationForAITool;
      return this._http.post(apiURL, reqModel).pipe();
    }

    reRunAutomationForQualifying(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.reRunAutomationForQualifying;
      return this._http.post(apiURL, reqModel).pipe();
    }
    
   changeFollowupFlagForReferralQuestion(reqModel): Observable<any> {
    const apiURL = this.baseUrlReferral + this.apiAddress.changeFollowupFlagForReferralQuestion;
    return this._http.post(apiURL, reqModel).pipe();
  }

   updatePDPMScoresForReferral(reqModel): Observable<any> {
      const apiURL = this.baseUrlTrans + this.apiAddress.updatePDPMScoresForReferral;
      return this._http.post(apiURL, reqModel).pipe();
    }

   trackUrlStatus(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.trackUrlStatus;
    return this._http.post(apiURL, reqModel).pipe();
  }

   getAllTrainingContent(reqModel: any): Observable<any> {
     const apiURL =this.baseUrlTrans + this.apiAddress.getAllTrainingContent;
     return this._http.post(apiURL, reqModel);
    }

    getGlobalContentforGuestPortal(reqModel): Observable<any> {
    const apiURL = this.baseUrlTrans + this.apiAddress.getGlobalContentforGuestPortal;
    // Retrieve the token from local storage
    const token = sessionStorage.getItem('LoginToken');

    // Prepare the headers
    const httpHeaders = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
    return this._http.post(apiURL, reqModel, { headers: httpHeaders }).pipe();
    //  const apiURL = this.baseUrlTrans + this.apiAddress.getPortalDataforHome;
    //  return this._http.post(apiURL, reqModel).pipe();
  }
}
